import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, Button, CardMedia } from '@mui/material';
import { Link } from 'react-router-dom';

const Banner = ({ banner }) => {
  const [videoEnded, setVideoEnded] = useState(false);
  const [imageVisible, setImageVisible] = useState(false);
  const videoRef = useRef(null);
  const navbarHeight = 64;

  useEffect(() => {
    const videoElement = videoRef.current;
    if (videoElement) {
      const handleEnded = () => {
        setVideoEnded(true);
        // Adiciona um pequeno atraso antes de mostrar a imagem para garantir que o fade out do vídeo termine
        setTimeout(() => {
          setImageVisible(true);
        }, 300); // Ajuste esse valor (em ms) conforme necessário
      };
      videoElement.addEventListener('ended', handleEnded);
      return () => {
        videoElement.removeEventListener('ended', handleEnded);
      };
    } else if (!banner?.video?.asset?.url) {
      // Se não houver vídeo, a imagem deve ser visível desde o início
      setImageVisible(true);
    }
  }, [banner?.video?.asset?.url]);

  if (!banner) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'relative',
        color: '#fff',
        width: '100%',
        height: {
          xs: `calc(100vh - ${navbarHeight}px)`,
          lg: `calc(100vh - ${navbarHeight}px)`,
        },
        display: 'flex',
        flexDirection: 'column', // Garante que os filhos (vídeo/imagem e conteúdo) sejam empilhados
        alignItems: 'center',
        justifyContent: 'center', // Centraliza verticalmente o conteúdo
        overflow: 'hidden',
      }}
    >
      {banner?.video?.asset?.url && !videoEnded ? (
        <video
          ref={videoRef}
          autoPlay
          muted
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 0,
            transition: 'opacity 0.3s ease-in-out',
            opacity: videoEnded ? 0 : 1,
          }}
        >
          <source src={banner.video.asset.url} type="video/mp4" />
          Seu navegador não suporta vídeos.
        </video>
      ) : (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url(${banner.snap?.asset?.url})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            zIndex: 0,
            opacity: imageVisible ? 1 : 0,
            transition: 'opacity 0.5s ease-in-out',
          }}
        />
      )}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          background: 'linear-gradient(0deg, rgba(18, 18, 18, 1) 6%, rgba(18, 18, 18, 0.75) 50%, transparent 100%)',
          zIndex: 1,
        }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center', // Centraliza verticalmente O CONTEÚDO INTERNO
          position: 'relative',
          zIndex: 2,
          maxWidth: { xs: '100%', lg: '512px' },
          px: 2,
          textAlign: 'center',
          mt: { xs: 0, lg: 'calc(100vh / -4)' }
        }}
      >
        <Typography 
          component={Link}
          to={`/${banner.core}`}
          align='center' variant="h6" color="textSecondary" 
            sx={{ 
              color: 'inherit',
              textDecoration: 'none',
              lineHeight: 1, textShadow: `0 .05rem .1rem rgba(18, 18, 18, .25)` 
            }}
          >
            {banner.core === 'atari2600' && 'Atari 2600'}
            {banner.core === 'gb' && 'Game Boy'}
            {banner.core === 'gbc' && 'Game Boy Color'}
            {banner.core === 'n64' && 'Nintendo 64'}
            {banner.core === 'nes' && 'Nintendo'}
            {banner.core === 'segaMS' && 'Sega Master System'}
            {banner.core === 'snes' && 'Super Nintendo'}
            {banner.core === 'psx' && 'Playstation'}
        </Typography>
        <Box sx={{ width: '100%', mb: 2 }}>
          {banner.logo?.asset?.url ? (
            <>
              <CardMedia
                component='img'
                alt={banner.name}
                src={banner.logo?.asset?.url}
                style={{
                  width: { xs: 320, lg: 512 },
                  height: 'auto'
                }}
              />
            </>
          ) : (
            <Typography align='center' noWrap variant="h4" fontWeight="bold" sx={{
              display: 'block',
              whiteSpace: { xs: 'nowrap', lg: 'inherit' }
            }}>
              {banner.name}
            </Typography>
          )}
        </Box>
        <Button
          component={Link}
          to={`/${banner.core}/${banner.slug?.current}`}
          variant="contained"
          fullWidth
          color="primary"
          size="large"
          sx={{
            fontSize: 'large',
            maxWidth: { xs: '100%', lg: '256px' },
          }}
        >
          Jogar
        </Button>
      </Box>
    </Box>
  );
};

export default Banner;